import { Stack } from "PFComponents/containers";
import { Typography } from "PFComponents/typography";
import { CustomValueTag } from "PFCore/types";
import { useTranslation } from "react-i18next";

import css from "./custom_value_pill_tooltip.module.scss";
import { InlineIconText } from "./inline_icon_text";

type TagsTooltipContentProps = {
  tags: CustomValueTag[];
};

export const TagsTooltipContent = ({ tags }: TagsTooltipContentProps) => {
  const { t } = useTranslation("core", { keyPrefix: "customValue" });

  return (
    <Stack>
      <Typography variant="labelRegular" className={css.tooltipColumnTitle}>
        {t("tags")}
      </Typography>
      {tags.map(({ id, iconName, displayAs }) => (
        <InlineIconText key={id} iconName={iconName} text={displayAs} white />
      ))}
    </Stack>
  );
};
